<template>
	<div class="ma-3">
		<ActivityToolbar
			:quickFilter="quickFilter"
			:advancedFilter="advancedFilter"
			:disableDetailedExport="disableDetailedExport"
			@quickFilterChanged="onQuickFilterChanged"
			@advancedFilterChanged="onAdvancedFilterChanged"
			@exportRecords="onExportRecords"
		/>
		<v-data-table
			dense
			:items="data"
			:headers="headers"
			hide-default-header
			:footer-props="{
				itemsPerPageOptions: [10, 15, 20, 25, 30, 50, 100],
				showFirstLastPage: true,
				showCurrentPage: true,
				pagination: {
					page,
					itemsPerPage: rowsPerPage,
					pageStart,
					pageStop,
					pageCount,
					itemsLength: totalCount,
				},
			}"
			:options.sync="options"
			:server-items-length="totalCount"
		>
			<template #header>
				<thead class="v-data-table-header">
					<tr>
						<th
							v-for="(header, index) in headers"
							:key="index"
							class="active"
						>
							<v-checkbox
								v-if="header.Value == 'SelectAll'"
								class="my-0"
								hide-details
								v-model="selectAll"
								@click="selectMethod(data, true)"
							>
							</v-checkbox>
							{{ header.Text }}
						</th>
					</tr>
					<tr
						v-if="loading && !headers.length > 0"
						class="v-data-table__progress"
					>
						<th :colspan="headers.length" class="column">
							<v-progress-linear
								indeterminate
							></v-progress-linear>
						</th>
					</tr>
				</thead>
			</template>
			<template #body>
				<tbody
					v-if="!loading && headers.length > 0"
					class="v-data-table-body"
				>
					<tr v-for="(item, index) in data" :key="index">
						<td v-for="column in headers" :key="column.Text">
							<template>
								<v-checkbox
									v-if="column.Value == 'SelectAll'"
									style="width: 10px"
									class="my-0"
									hide-details
									:input-value="isRowSelected(item)"
									@click="selectMethod([item], false)"
								></v-checkbox>
								<span v-if="column.Type == 'ConditionField'">
									{{
										getListValue(
											conditionFieldsList.find(
												(x) => x.Label == column.Text
											),
											item
										)
									}}
								</span>
								<span v-if="column.Type == 'ComputedField'">
									{{ getComputedFieldValue(item, column) }}
								</span>
								<span v-if="column.Type == 'StaticField'">
									{{ item[column.Value] }}
								</span>
							</template>
						</td>
					</tr>
				</tbody>
			</template>
		</v-data-table>
	</div>
</template>
<script>
import { ActivityActions } from '../../store/actions';
import { ActivityGetters } from '../../store/getters';
import { mapGetters } from 'vuex';
import gridViewFieldUtils from '../../utils/gridViewFieldsUtils';
import ActivityToolbar from './ActivityToolbar.vue';
export default {
	name: 'ActivityGrid',
	components: { ActivityToolbar },
	data() {
		return {
			headers: [],
			selectedRows: [],
			selectAll: false,
			disableDetailedExport: false,
		};
	},
	watch: {
		selectedRows(newVal) {
			let areEqual = true;
			if (newVal.length == 0) this.disableDetailedExport = true;
			else this.disableDetailedExport = false;
			let arr1 = new Set(newVal.map(JSON.stringify));
			let arr2 = new Set(this.data.map(JSON.stringify));
			arr2.forEach((item) => {
				if (!arr1.has(item)) {
					return (areEqual = false);
				}
			});
			this.selectAll = areEqual;
		},
	},
	computed: {
		...mapGetters({
			data: [ActivityGetters.DATA],
			staticFields: [ActivityGetters.STATIC_FIELDS],
			coumputedFields: [ActivityGetters.COMPUTED_FIELDS],
			groupByFields: [ActivityGetters.GROUP_BY_FIELDS],
			conditionFieldsList: [ActivityGetters.CONDITION_FIELDS_LIST],
			quickFilter: [ActivityGetters.QUICK_FILTER],
			advancedFilter: [ActivityGetters.ADVANCED_FILTER],
			page: [ActivityGetters.PAGE],
			rowsPerPage: [ActivityGetters.ROWS_PER_PAGE],
			totalCount: [ActivityGetters.TOTAL_COUNT],
			loading: [ActivityGetters.LOADING],
		}),
		pageStart() {
			return this.rowsPerPage * (this.page - 1);
		},
		pageStop() {
			return this.rowsPerPage * this.page;
		},
		pageCount() {
			if (!this.rowsPerPage) return 0;
			if (!this.totalCount) return 0;
			let quotient = Math.floor(this.totalCount / this.rowsPerPage);
			let reminder = this.totalCount % this.rowsPerPage;
			if (reminder === 0) return quotient;
			return quotient + 1;
		},
		options: {
			get() {
				return {
					page: this.page,
					itemsPerPage: this.rowsPerPage,
				};
			},
			set(data) {
				if (this.page != data.page && !isNaN(data.page))
					this.$store.dispatch(ActivityActions.UPDATE_PAGE, {
						page: data.page,
						id: this.$route.params.activityId,
					});
				if (
					this.rowsPerPage != data.itemsPerPage &&
					!isNaN(data.itemsPerPage)
				)
					this.$store.dispatch(ActivityActions.UPDATE_ROWS_PER_PAGE, {
						rowsPerPage: data.itemsPerPage,
						id: this.$route.params.activityId,
					});
			},
		},
	},
	methods: {
		setHeaders() {
			let result = [];
			result.push({ Text: '', Value: 'SelectAll' });
			this.conditionFieldsList.forEach((list) => {
				result.push({
					Text: list.Label,
					Value: list.Id,
					Type: 'ConditionField',
				});
			});
			this.staticFields.forEach((x) => {
				result.push({ Text: x.Name, Value: x.Id, Type: 'StaticField' });
			});
			this.coumputedFields.forEach((x) => {
				result.push({
					Text: x.Name,
					Value: x.Id,
					Type: 'ComputedField',
				});
			});
			this.headers = result;
		},
		selectMethod(rows, isFromHeader) {
			if (isFromHeader === true) {
				this.data.forEach((fi) => {
					let index = this.selectedRows.indexOf(fi);
					if (isFromHeader && this.selectAll) {
						if (index < 0) this.selectedRows.push(fi);
					} else if (isFromHeader && this.selectAll == false) {
						if (index >= 0) this.selectedRows.splice(index, 1);
					}
				});
			} else {
				rows.forEach((row) => {
					let index = this.selectedRows.indexOf(row);
					if (isFromHeader === false) {
						if (index >= 0) {
							this.selectedRows.splice(index, 1);
						} else {
							this.selectedRows.push(row);
						}
					}
				});
			}
		},
		onExportRecords() {
			this.$store.dispatch(
				ActivityActions.EXPORT_ACTIVITY_DETAILED_DATA,
				{
					id: this.$route.params.activityId,
					rows: this.selectedRows,
				}
			);
			// alert("To be implemented")
		},
		getComputedFieldValue(item, column) {
			let val = item[column.Value];
			if (val == null) return 0;
			return item[column.Value];
		},
		getListValue(list, item) {
			let result = [];
			list.GridViewFields.forEach((l) => {
				result.push(item[gridViewFieldUtils.getFieldName(l)]);
			});
			return result.join(',');
		},
		onQuickFilterChanged(value) {
			let param = {
				filter: value,
				id: this.$route.params.activityId,
			};
			this.$store.dispatch(ActivityActions.UPDATE_QUICK_FILTER, param);
		},
		onAdvancedFilterChanged(value) {
			let param = {
				filter: value,
				id: this.$route.params.activityId,
			};
			this.$store.dispatch(ActivityActions.UPDATE_ADVANCED_FILTER, param);
		},
		isRowSelected(row) {
			if (!this.selectedRows) return false;
			if (!row) return false;
			let item = this.selectedRows.find((x) => x == row);
			if (item) return true;
			return false;
		},
	},
	destroyed() {
		this.$store.dispatch(ActivityActions.CLEAR);
	},
	mounted() {
		this.disableDetailedExport = true;
		this.$store
			.dispatch(
				ActivityActions.LOAD_ACTIVITY_DATA,
				this.$route.params.activityId
			)
			.then(() => {
				this.setHeaders();
			});
	},
};
</script>
